import {
  DownOutlined,
  FolderOpenFilled,
  FolderOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { Spin, Tree } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';

const CategoriesTree = ({ categories = [], onSelect, loading = false }) => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);

  // Transformer les données de catégories au format Tree d'Ant Design
  const treeData = useMemo(() => {
    if (!categories || !Array.isArray(categories)) return [];

    const transformCategory = (category) => {
      const treeNode = {
        title: category.name,
        key: category.id.toString(),
        id: category.id,
        isLeaf: category.is_leaf_node,
        isRoot: category.is_root_node,
        isArchived: category.is_archived,
        technicalAttributes: category.technical_attributes,
        marketingAttributes: category.marketing_attributes,
        createdAt: category.created_at,
        updatedAt: category.updated_at,
        icon: category.is_leaf_node ? (
          <FolderOutlined style={{ color: '#22247B' }} />
        ) : (
          <FolderOpenFilled style={{ color: '#22247B' }} />
        ),
      };

      // Si la catégorie a des enfants, les transformer récursivement
      if (category.children && category.children.length > 0) {
        treeNode.children = category.children.map(transformCategory);
      }

      return treeNode;
    };

    return categories.map(transformCategory);
  }, [categories]);

  // Générer toutes les clés pour l'expansion par défaut
  const getAllKeys = useMemo(() => {
    const keys = [];

    const extractKeys = (nodes) => {
      nodes.forEach((node) => {
        keys.push(node.key);
        if (node.children && node.children.length > 0) {
          extractKeys(node.children);
        }
      });
    };

    if (treeData && treeData.length > 0) {
      extractKeys(treeData);
    }

    return keys;
  }, [treeData]);

  // Définir les clés expandues par défaut quand les données changent
  useEffect(() => {
    if (getAllKeys.length > 0) {
      setExpandedKeys(getAllKeys);
    }
  }, [getAllKeys]);

  const handleSelect = (selectedKeys, info) => {
    setSelectedKeys(selectedKeys);
    if (onSelect) {
      onSelect(selectedKeys, info);
    }
  };

  const handleExpand = (expandedKeys, info) => {
    setExpandedKeys(expandedKeys);
    console.log('Expanded keys:', expandedKeys, info);
  };

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Spin indicator={<LoadingOutlined spin />} />
        <span style={{ marginLeft: '10px' }}>Chargement des catégories...</span>
      </div>
    );
  }

  if (!treeData || treeData.length === 0) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
        Aucune catégorie trouvée
      </div>
    );
  }

  return (
    <Tree
      treeData={treeData}
      onSelect={handleSelect}
      onExpand={handleExpand}
      switcherIcon={<DownOutlined />}
      selectedKeys={selectedKeys}
      expandedKeys={expandedKeys}
      showLine={{ showLeafIcon: false }}
      showIcon={true}
      selectable={true}
      multiple={false}
      blockNode={false}
      style={{
        backgroundColor: 'transparent',
        fontSize: '14px',
      }}
    />
  );
};

export default CategoriesTree;
